import { Component, OnInit, inject } from '@angular/core';
import {HeaderComponent} from "../../../common/header/header.component";
import {FooterComponent} from "../../../common/footer/footer.component";
import { NgOptimizedImage } from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LocaleService} from "../../../../locale/locale.service";
import {ClaimsService} from "../../../../services/claims.service";
import {UserType} from "../../../../enums/user-type";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';

@Component({
  selector: 'app-user-participation-identification',
  imports: [
    HeaderComponent,
    FooterComponent,
    NgOptimizedImage,
    FormsModule
],
  templateUrl: './user-participation-identification.component.html',
  styleUrl: './user-participation-identification.component.css'
})
export class UserParticipationIdentificationComponent implements OnInit {
  private claimService = inject(ClaimsService);
  private formNavigationService = inject(FormNavigationService);
  locale = inject(LocaleService);

  public showError = false;
  public showAdditionalInformation = false;
  isDriver: boolean | null = null;

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.userType) {
        this.isDriver = this.claimService.isDriver();
      }
    })
  }

  nextClicked() {
    this.evaluateShowError();


    if (this.isDriver === null) return;
    const userType = this.isDriver ? UserType.FirstParty : UserType.ThirdParty;
    this.claimService.updateClaimReport({userType});
    this.claimService.save().subscribe(() => {
      this.formNavigationService.navigate(NavigationKey['user-participation'], [this.isDriver]);
    });
  }


  private evaluateShowError() {
    this.showError = this.isDriver === null;
  }

  onSelectionChange(value: boolean) {
    this.isDriver = value;
    this.evaluateShowError();
    this.claimService.resetClaimReport();
  }
}
